import CanceledStorePage from 'domains/Account/pages/CanceledStorePage';
import UpsellBlockPage from 'domains/Billing/UpsellFlow/pages/UpsellBlockPage';
import { useUpsellBlock } from '../UpsellFlow/hooks';

function CancelledStateDecider() {
  const { upsellHardBlock } = useUpsellBlock();

  return upsellHardBlock ? <UpsellBlockPage /> : <CanceledStorePage />;
}

export default CancelledStateDecider;
